import { c as _c } from "react/compiler-runtime";
import { AccountUIApiProvider } from '@newfront-insurance/account-ui';
import type { PropsWithChildren, JSX } from 'react';
export function AccountUIProvider(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <AccountUIApiProvider basePath="/api/account-ui">{children}</AccountUIApiProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}